import { Node } from "@xyflow/react";
import { atom } from "jotai";

export const sidebarOpenNodeIdAtom = atom<Node["id"]>("");

sidebarOpenNodeIdAtom.debugLabel = "sidebarOpenNodeIdAtom";
